import API from "@/models/API";

export default class BusinessStatistics {
    static get = (query,filters) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/statistics${query}${filters}`);
    
    static getTotals = (query,filters) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/statistics${query}${filters}`);

    static getActiveUsers = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/statistics/active-users`);

    static getLast2MonthsActiveUsers = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/statistics/active-users-two-months`);

    static getCompanyRegions = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/network-regions`);

    static getExportedFile = () =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/business-statistics`
        );

    static exportFile = (body) =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/business-statistics`,
            body
        );

    static deleteExportedFile = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/business-statistics/${id}`
        );
 }
